import pubsub from "@viewlift/pubsub"
import Cookies from "js-cookie"
import logger from "../logger";


  let requestorID = window?.app_data.appcmsPlatform.tveSettings.requestorID
  let softwareStatement = window?.app_data.appcmsPlatform.tveSettings.softwareStatement
  let AccessEnablerUrl = window?.app_data.appcmsPlatform.tveSettings.accessEnabler


export const loadScript = (src) =>
    new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve()
        const script = document.createElement('script')
        script.src = `${src}`
        script.onload = () => resolve()
        script.onerror = (err) => reject(err)
        document.body.appendChild(script)
    })

window.accessEnablerDidLoad = () => {
    let ss = softwareStatement
    if(window && "AccessEnabler" in window){
        window.AE = new window.AccessEnabler.AccessEnabler(ss)
        window?.entitlementLoaded();
    }
}

window.entitlementLoaded = () => {
    window.AE.setRequestor(requestorID);
    window?.setConfig()
}

window.setConfig = (configuration) => {
  window?.AE?.checkAuthentication()
}

window.setAuthenticationStatus = (isAuthenticated, errorCode) => {
    if(isAuthenticated == 1){
        window?.AE?.getMetadata('zip')
        window?.AE?.getMetadata('householdID')
        window?.AE?.getMetadata('hba_status')
    }else if(isAuthenticated == 0 ){
          logger(`user none ${errorCode}`)
    }
}


window.setMetadataStatus = (key, encrypted, data) => {
    if(key==="householdID" || key==="hba_status"){
        Cookies.set(key,data)
    }
  }

  window.displayProviderDialog = (mvpdList) => {
   return true
  }  

  window.setToken = (inRequestedResourceID, inToken) => {
    pubsub.publish('tveAuthz',{inRequestedResourceID, inToken})
}

window.tokenRequestFailed = (inRequestedResourceID, inRequestErrorCode, inRequestDetailedErrorMessage) => {
    pubsub.publish('tveAuthz',{inRequestedResourceID, inRequestErrorCode, inRequestDetailedErrorMessage})
}

window.sendTrackingData = (trackingEventType, trackingData) => {
}

const loadTve = () => {
    let src = AccessEnablerUrl;
    if(src) {
        return loadScript(src)
        .then(() => {
            window.accessEnablerDidLoad()
            return true
        })
    } else {
        return false
    }
}

export default loadTve;